import { render, staticRenderFns } from "./PlansDropdown.vue?vue&type=template&id=388c40ea"
import script from "./PlansDropdown.vue?vue&type=script&lang=js"
export * from "./PlansDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports